import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { DatabaseService } from './db-service';

import { User } from '../models';
import { AuthService } from './auth-service';

@Injectable({
  providedIn: 'root'
})

export class UserService {

    userObj: User;
    public collection: string = 'users';

    constructor(
        private afstore: AngularFirestore,
        private authService: AuthService,
        private dbservice: DatabaseService) {
    }

    public GetUserRoleList = (): string[] => {
        return ['Priest', 'Servant'];
    }

    /**
     * Initiate the login process for this user
     * @param isActive indicates that user is Active
     * @param isDeleted indicates that user is Deleted
     */
    public getUsers(isActive: boolean, isDeleted: boolean) {
        return this.dbservice.getDocuments(this.collection, ref => ref
            .where('isActive', '==', isActive)
            .where('isDeleted', '==', isDeleted)
        );
    }

    // CRUD functions
    // Create
    public async createUser(user: User) {
        const id = this.afstore.createId();
        const firebaseUser = await this.authService.createFirebaseUser(user.email, id);
        this.afstore.collection(this.collection).doc(firebaseUser.uid).set(user);
        return firebaseUser.uid;
    }
}
